// src/data.js

import products1 from './productsimg/1.png';
import products2 from './productsimg/2.png';
import products3 from './productsimg/3.png';
import products4 from './productsimg/4.png';
import products5 from './productsimg/5.png';
import products6 from './productsimg/6.png';
import products7 from './productsimg/7.png';
import products8 from './productsimg/8.png';
import products9 from './productsimg/9.png';
import products10 from './productsimg/10.png';
import products11 from './productsimg/11.png';
import products12 from './productsimg/12.png';
import products13 from './productsimg/13.png';
import products14 from './productsimg/14.png';

export const dressPage1 = [
  {
    id: 1,
    images: products1,
    brand: "INCENSE STICKS",
    title: "Shiv Arpan Agarbatti",
    discountedPrice: 1299,
    price: 2499,
    discountPersent: 50,
    description: "High-quality agarbatti with spiritual fragrance for a calming experience."
  },
  {
    id: 2,
    images: products2,
    brand: "INCENSE STICKS",
    title: "Shiv Arpan Dhoopcones",
    discountedPrice: 341,
    price: 1899,
    discountPersent: 82,
    description: "Premium dhoopcones for everyday rituals and meditative ambiance."
  },
  {
    id: 3,
    images: products3,
    brand: "INCENSE STICKS",
    title: "Rose & Marigold Agarbatti",
    discountedPrice: 499,
    price: 1999,
    discountPersent: 75,
    description: "Blended floral incense sticks for a soothing atmosphere."
  },
  {
    id: 4,
    images: products4,
    brand: "INCENSE STICKS",
    title: "Lotus Agarbatti",
    discountedPrice: 359,
    price: 2099,
    discountPersent: 82,
    description: "Lotus-scented sticks made with traditional purity and care."
  },
  {
    id: 5,
    images: products5,
    brand: "INCENSE STICKS",
    title: "Pushpanjali Incense Sticks",
    discountedPrice: 359,
    price: 2099,
    discountPersent: 82,
    description: "Divine blend for pooja rituals and serenity at home."
  },
  {
    id: 6,
    images: products6,
    brand: "INCENSE STICKS",
    title: "Pushpanjali Incense Sticks",
    discountedPrice: 827,
    price: 1799,
    discountPersent: 54,
    description: "Traditional Indian incense for divine spiritual practice."
  },
  {
    id: 7,
    images: products7,
    brand: "INCENSE CONES",
    title: "Lotus Dhoopcones",
    discountedPrice: 499,
    price: 2497,
    discountPersent: 80,
    description: "Fragrant lotus cones for holistic and aromatic relaxation."
  },
  {
    id: 8,
    images: products8,
    brand: "INCENSE CONES",
    title: "Rose & Marigold Dhoopcones",
    discountedPrice: 449,
    price: 1499,
    discountPersent: 70,
    description: "Double fragrance dhoopcones with rose and marigold essence."
  },
  {
    id: 9,
    images: products9,
    brand: "INCENSE CONES",
    title: "Shiv Arpan Dhoopcones",
    discountedPrice: 719,
    price: 1999,
    discountPersent: 64,
    description: "Spiritual dhoopcones inspired by the divinity of Shiv Arpan."
  },
  {
    id: 10,
    images: products10,
    brand: "INCENSE CUPS",
    title: "Sambrani Cups",
    discountedPrice: 349,
    price: 1999,
    discountPersent: 65,
    description: "Sambrani cups for rich, traditional spiritual fragrance."
  },
  {
    id: 11,
    images: products11,
    brand: "GIFT HAMPERS",
    title: "Econimit All Products Gift Hamper",
    discountedPrice: 299,
    price: 1997,
    discountPersent: 85,
    description: "Perfect gift set with assorted incense and spiritual items."
  },
  {
    id: 12,
    images: products12,
    brand: "GIFT HAMPERS",
    title: "Econimit Gift Hamper",
    discountedPrice: 499,
    price: 2330,
    discountPersent: 78,
    description: "Premium hamper with a variety of calming incense products."
  },
  {
    id: 13,
    images: products13,
    brand: "GULAB JAL",
    title: "Econirmit Gulab Jal",
    discountedPrice: 359,
    price: 1799,
    discountPersent: 80,
    description: "Natural rose water for pooja and personal refreshment."
  },
  {
    id: 14,
    images: products14,
    brand: "ASHTAGANDHA",
    title: "Econimit Ashtagandha",
    discountedPrice: 474,
    price: 1289,
    discountPersent: 47,
    description: "Sandalwood and herbal ashtagandha for spiritual rituals."
  }
];
